'use client';

import Script from 'next/script';
import { GTMParams } from './types/gtm';
import { DEFAULT_DATA_LAYER_NAME, DEFAULT_GTM_SRC } from './constants';

/**
 * Google Tag Manager Component
 * @param {GTMParams} props - Component props
 */
export default function GoogleTagManager({
  gtmId,
  auth,
  preview,
  dataLayerName = DEFAULT_DATA_LAYER_NAME,
  src = DEFAULT_GTM_SRC,
}: GTMParams): JSX.Element {
  const gtmParams = new URLSearchParams({
    id: gtmId,
    ...(dataLayerName !== DEFAULT_DATA_LAYER_NAME && { l: dataLayerName }),
    ...(auth && { gtm_auth: auth }),
    ...(preview && { gtm_preview: preview, gtm_cookies_win: '' }),
  });

  if (!gtmId) {
    return <></>;
  }

  return (
    <>
      <Script
        id="_gtm-init"
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s);j.async=true;j.src='${src}?id='+i;f.parentNode.insertBefore(j,f);})
            (window,document,'script','${dataLayerName}','${gtmId}');
          `,
        }}
        onLoad={() => {
          console.debug('GTM loaded')
        }}
        onError={(error) => {
          console.error('GTM error', error)
        }}
      />
      <Script id="impact-accelerator-gtm" data-ntpc="GTM" src={`${src}?${gtmParams.toString()}`} />
    </>
  );
}
